import { createContext, useState } from 'react';
import api from 'services/api';

const filter = {
  like: '',
  id: '',
  grupo: '',
  descricao: '',
  ativo: null,
};

export const GrupoProdutoContext = createContext();

export const GrupoProdutoProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [grupoProduto, setGrupoProduto] = useState({
    data: [],
    colunas: [],
    filter,
    page: 0,
    size: 10,
  });

  const getGrupoProduto = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: grupoProduto?.filter,
        page: grupoProduto?.page,
        size: grupoProduto?.size,
        order: grupoProduto?.order,
        ...payload,
      });
      setGrupoProduto((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <GrupoProdutoContext.Provider
      value={{
        getLoading,
        grupoProduto,
        getGrupoProduto,
      }}
    >
      {children}
    </GrupoProdutoContext.Provider>
  );
};
